import React from 'react';
import { Container, RadioGroup, RadioButton, RadioLabel } from './styles';

export default function GoalSelector({ selectedGoal, onGoalChange }) {
  return (
    <Container>
      <RadioLabel>Meta em:</RadioLabel>
      <RadioGroup>
        <RadioButton>
          <input
            type="radio"
            id="toneladas"
            name="goal"
            value="toneladas"
            checked={selectedGoal === 'toneladas'}
            onChange={(e) => onGoalChange(e.target.value)}
          />
          <label htmlFor="toneladas">Toneladas</label>
        </RadioButton>
        <RadioButton>
          <input
            type="radio"
            id="p13"
            name="goal"
            value="p13"
            checked={selectedGoal === 'p13'}
            onChange={(e) => onGoalChange(e.target.value)}
          />
          <label htmlFor="p13">P13</label>
        </RadioButton>
      </RadioGroup>
    </Container>
  );
}
